<template>
    <v-dialog
        :value="visible"
        max-width="500"
        :attach="false"
        :z-index="9999"
        @input="onDialogInput"
    >
        <v-card>
            <v-card-title>Color Picker</v-card-title>

            <v-card-text>
                <p
                    v-if="show_conversion_note"
                    class="mt-0 mb-4"
                >
                    The selected color will automatically be converted to Hex or RGB after clicking OK,
                    depending on your selected preference. Alpha values will be ignored.
                </p>

                <v-color-picker
                    :value="color_value"
                    show-swatches
                    dot-size="25"
                    width="500"
                    canvas-height="150"
                    swatches-max-height="200"
                    @input="onColorInput"
                />
            </v-card-text>

            <v-card-actions>
                <v-spacer />

                <v-btn
                    text
                    @click="onCancel"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary"
                    text
                    @click="onSelect"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },

        color_value: {
            type: Object,
            default: () => ({ r: 255, g: 255, b: 255, a: 1 }),
        },

        show_conversion_note: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        onDialogInput(value) {
            this.$emit('update:visible', value);
        },

        onColorInput(color) {
            this.$emit('update:color_value', color);
        },

        onCancel() {
            this.$emit('cancel');
        },

        onSelect() {
            this.$emit('select', this.color_value);
        },
    },
};
</script>